import VendorSelectorAurora from "../aurora/VendorSelector/VendorSelectorAurora";
import VendorSelectorClassic from "../classic/VendorSelector/VendorSelectorClassic";

// Define el tipo del componente Login
interface VendorSelectorComponent {
  Classic: typeof VendorSelectorClassic;
  Aurora: typeof VendorSelectorAurora;
}

// Crear el contenedor lógico
const VendorSelector: VendorSelectorComponent = {
  Classic: VendorSelectorClassic,
  Aurora: VendorSelectorAurora,
};

export default VendorSelector;
